export default {
  title: 'Payment information verified',
  description: 'Your payment information has been successfully verified.',
};
